import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { Entities } from 'src/enums'
import { DataLoggerGetReadingsResponse } from 'src/api'
import { useApiInstance } from './useApiInstance'

interface RequestParams {
  deviceId: string;
  params?: {
    dateFrom?: string;
    dateTo?: string;
  };
  options?: Omit<
    UseQueryOptions<unknown, Error, DataLoggerGetReadingsResponse>,
    'queryKey' | 'queryFn'
  >;
}

export const useDataLoggerReadingsRequest = ({
  deviceId,
  params = {},
  options,
}: RequestParams) => {
  const api = useApiInstance()
  return useQuery<unknown, Error, DataLoggerGetReadingsResponse>(
    [Entities.DataLoggers, 'readings', deviceId],
    async () => {
      const { dateFrom, dateTo } = params
      const { data } = await api.v1AdminDataLoggersDeviceIdReadingsGet(
        deviceId,
        dateFrom,
        dateTo,
      )
      return data
    },
    options,
  )
}
